var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { RosterTemplate } from '@/models/RosterTemplate';
import DataTable from '@/components/data-table/DataTable';
import ErrorHandler from '@/support/ErrorHandler';
import { formatDate } from '@/support/String';
import CreateTemplateDialog from './CreateTemplateDialog';
let RosterTemplates = class RosterTemplates extends Vue {
    constructor() {
        super(...arguments);
        this.selectedRosterTemplate = new RosterTemplate();
        this.isCreatingNewTemplate = false;
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('rosterTemplate.title', 1),
                plural: this.$tc('rosterTemplate.title', 2),
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'title',
                    action: '/roster/templates/{id}',
                },
                {
                    text: this.$t('rosterTemplate.createdAt'),
                    value: 'created_at',
                    transform: (date) => {
                        return formatDate(date, 'dd-LL-yyyy HH:mm');
                    },
                },
                {
                    text: this.$t('rosterTemplate.updatedAt'),
                    value: 'updated_at',
                    transform: (date) => {
                        return formatDate(date, 'dd-LL-yyyy HH:mm');
                    },
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    action: '/roster/templates/{id}',
                },
                {
                    type: 'duplicate',
                    label: 'duplicate',
                    icon: 'file_copy',
                    action: (vm, rosterTemplate) => {
                        this.handleDuplicate(rosterTemplate);
                    },
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, rosterTemplate) => {
                        this.handleTableDelete(rosterTemplate);
                    },
                },
            ],
            filters: [],
            model: new RosterTemplate(),
        };
    }
    get dialogOptions() {
        const rosterTemplate = this.selectedRosterTemplate;
        return {
            title: rosterTemplate.title || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.template') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!rosterTemplate) {
                            return;
                        }
                        rosterTemplate
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.selectedRosterTemplate = new RosterTemplate();
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedRosterTemplate = new RosterTemplate();
                    },
                },
            },
        };
    }
    get breadcrumbs() {
        return [{
                name: this.$tc('rosterTemplate.title', 2),
                path: '/roster/templates',
            }];
    }
    mounted() {
        //
    }
    initialize() {
        //
    }
    handleDuplicate(rosterTemplate) {
        rosterTemplate
            .duplicate(rosterTemplate.id || '')
            .create()
            .then(() => {
            this.refreshDataTable();
            rosterTemplate.default();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    handleTableDelete(rosterTemplate) {
        this.selectedRosterTemplate = rosterTemplate;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    refreshDataTable() {
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    handleTemplateCreated(rosterTemplate) {
        this.refreshDataTable();
        this.$router.push(`/roster/templates/${rosterTemplate.id}`);
    }
};
RosterTemplates = __decorate([
    Component({
        components: {
            PageHeader,
            DataTable,
            CreateTemplateDialog,
        },
    })
], RosterTemplates);
export default RosterTemplates;
